// Imports
import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
//import { trailingSlash } from '@/util/helpers'
import {
  layout,
  route,
} from '@/util/routes'

Vue.use(Router)

/*const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash }
    if (savedPosition) return savedPosition

    return { x: 0, y: 0 }
  },
  routes: [
    layout('Default', [
      route('Login', null, 'login'),
      route('Disaster Management', null, 'disaster_management'),
      //route('Asset Management', null, 'asset_management'),
      route('Project Application', null, 'project_application'),
      route('ProvinceProjectApplicationProvision', null, 'project_application_provision'),
      route('ManagementOfReconstructionPlan', null, 'disaster_need'),
      route('ProjectApplication Approval', null, 'project_application_approval'),
      route('Project Budget', null, 'project_budget'),
      route('Contractor AndVFMStatement', null, 'project_contractor'),
      route('Implementation Reporting', null, 'implementation_reporting'),
      route('Implementation Approval', null, 'implementation_approval'),
      route('Payment Progress', null, 'payment_progress'),
      route('Completion Reporting', null, 'completion_reporting'),
      route('Completion Approval', null, 'completion_approval'),
      route('Project Overview', null, 'project_overview'),
      //route('Project Details Management', null, 'project_details_management'),
      //route('Project Monitoring', null, 'project_monitoring'),
      route('Dashboard', null, 'dashboard'),
      route('SearchFunction', null, 'search_function'),
      route('UserRightManagement', null, 'user_right_management'),
      route('HomePage', null, 'home_page'),

    ]),
  ],
})

router.beforeEach((to, from, next) => {
  return to.path.endsWith('/') ? next() : next(trailingSlash(to.path))
})*/

/*router.beforeEach((to, from, next) => {
  store.dispatch('auth/authenticate').then(response => {
    next()
  }).catch(error => {
    if (!error.message.includes('Could not find stored JWT')) {
      console.log('Authentication error', error)
    }
    (to.meta.requiresAuth) ? next('/inicio-sesion') : next()
  })

})*/

//test not working
/*router.beforeEach((to, from, next) => {
  console.log('****store', store.get('auth/loggedIn'));
  if(store.get('auth/loggedIn')){
    console.log('if');
    return to.path.endsWith('/') ? next() : next(trailingSlash(to.path))
  }else{
    console.log('else');
    return to.path('/login'); //to.path.endsWith('/login') ? next() : next(trailingSlash(to.path))
  }
})*/

/*router.beforeEach((to, from) => {
  console.log('****store loggedIn', store.get('auth/loggedIn'));
  console.log('****to.meta', to.meta);
  // instead of having to check every route record with
  // to.matched.some(record => record.meta.requiresAuth)
  //if (to.meta.requiresAuth && !auth.isLoggedIn()) {
  if (to.meta.requiresAuth && !store.get('auth/loggedIn')) {
    console.log('test');
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    return {
      path: '/login',
      // save the location we were at to come back later
      query: { redirect: to.fullPath },
    }
  }
})*/

/*router.beforeEach((to, from, next) => {
  //const token = localStorage.getItem('access_token')

  console.log('****store loggedIn', store.get('auth/loggedIn'));

  //if not logged in, redirect to Login page
  if (store.get('auth/loggedIn')) return '/login' //next ('/login');

  //else continue
  else next();
});*/


//TEST ALMOST
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash }
    if (savedPosition) return savedPosition
    return { x: 0, y: 0 }
  },

  routes: [
    layout('Default', [
    {
      path: "/",
      redirect: "home_page"
    },
    {
      path: "/home_page",
      name: "Home Page",
      component: () => import("../views/HomePage.vue"),
      meta: {
        requiresAuth: true
      }
    },{
      path: "/disaster_management",
      name: "Management of affected areas",
      component: () => import("../views/DisasterManagement.vue"),
      meta: {
        requiresAuth: true
      }
    },{
      path: "/disaster_need",
      name: "Notification of Rehabilitation Plan Submission",
      component: () => import("../views/ManagementOfReconstructionPlan.vue"),
      meta: {
        requiresAuth: true
      }
    },{
      path: "/project_application_provision",
      name: "Notification of Project Plan Provision",
      component: () => import("../views/ProvinceProjectApplicationProvision.vue"),
      meta: {
        requiresAuth: true
      }
    },{
      path: "/project_application",
      name: "Project Application",
      component: () => import("../views/ProjectApplication.vue"),
      meta: {
        requiresAuth: true
      }
    },{
      path: "/project_application_approval",
      name: "Project Application Approval",
      component: () => import("../views/ProjectApplicationApproval.vue"),
      meta: {
        requiresAuth: true
      }
    },{
      path: "/project_contractor",
      name: "Contractor And VFM Statement",
      component: () => import("../views/ContractorAndVFMStatement.vue"),
      meta: {
        requiresAuth: true
      }
    },{
      path: "/project_id_budget_mgt",
      name: "Budget Management",
      component: () => import("../views/ProjectIdBudgetMgt.vue"),
      meta: {
        requiresAuth: true
      }
    },{
      path: "/project_budget",
      name: "Rehabilitation Plan Implementation",
      component: () => import("../views/ProjectBudget.vue"),
      meta: {
        requiresAuth: true
      }
    },{
      path: "/implementation_reporting",
      name: "Project Progress Reporting",
      component: () => import("../views/ImplementationReporting.vue"),
      meta: {
        requiresAuth: true
      }
    },{
      path: "/implementation_approval",
      name: "Project Progress Reporting Approval",
      component: () => import("../views/ImplementationApproval.vue"),
      meta: {
        requiresAuth: true
      }
    },{
      path: "/payment_progress",
      name: "Payment Update",
      component: () => import("../views/PaymentProgress.vue"),
      meta: {
        requiresAuth: true
      }
    },{
      path: "/completion_reporting",
      name: "Project Completion Reporting",
      component: () => import("../views/CompletionReporting.vue"),
      meta: {
        requiresAuth: true
      }
    },{
      path: "/completion_approval",
      name: "Project Completion Reporting Approval",
      component: () => import("../views/CompletionApproval.vue"),
      meta: {
        requiresAuth: true
      }
    },{
      path: "/project_overview",
      name: "Project Overview",
      component: () => import("../views/ProjectOverview.vue"),
      meta: {
        requiresAuth: true
      }
    },{
      path: "/user_right_management",
      name: "User Right Access Management",
      component: () => import("../views/UserRightManagement.vue"),
      meta: {
        requiresAuth: true
      }
    },{
      path: "/info",
      name: "Info",
      component: () => import("../views/Info.vue"),
      meta: {
        requiresAuth: true
      }
    },{
      path: "/login",
      component: () => import("../views/Login.vue")
    },
    {
      path: "*",
      component: () => import("../views/Login.vue")
    }
  ]
    )
  ]
});

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && !store.get('auth/loggedIn') ) {
    //console.log("user not logged in...redirecting to login");
      next("/login");
  } else {
    next();
  }
});


export default router
